/**
 * create by zpf 2018-07-27
 * 全局单元库,存储项目组成的业务单元
 */
class appModel {
  constructor () {
    this.apps = {}
  }

  /**
   * 注册app模块
   * @param name app名称
   * @param app app主体
   */
  registerApp (name, app) {
    if (!this.apps[name] && app)
      this.apps[name] = app
  }

  /**
   * 批量注册app模块
   * @param apps app列表
   */
  registerApps (apps) {
    this.apps = {
      ...this.apps,
      ...apps
    }
  }

  /**
   * 获取app
   * @param name app名称
   * @return {*}
   */
  getApp (name) {
    // 如果存在app对象,则返回
    let app = this.apps[name]
    if (app) return app

    throw `app${name}没有注册`
  }

  /**
   * 获取所有的app
   * @return {*}
   */
  getApps = () => {
    return this.apps
  }
}

const appInstance = new appModel()

export default appInstance


// WEBPACK FOOTER //
// ./src/wbap-core-commit/model/appModel.js